export function mergeLifeCycleActionHandlers(lifecycleActionHandlers, componentActionHandlers) {
	const mergedActionHandlers = {};

	for (const k in componentActionHandlers) {
		mergedActionHandlers[k] = mergedActionHandlers[k] || [];
		mergedActionHandlers[k].push(componentActionHandlers[k]);
	}

	for (const k in lifecycleActionHandlers) {
		const actionHandlers = lifecycleActionHandlers[k] || [];
		mergedActionHandlers[k] = mergedActionHandlers[k] || [];
		mergedActionHandlers[k] = [...mergedActionHandlers[k], ...actionHandlers];
	}

	return mergedActionHandlers;
}
